// extracted by mini-css-extract-plugin
export default {"globalSearch":"GlobalSearch_globalSearch__YyLdR"};